<template>
  <div class="juristic-feature-row">
    <img class="icon" :src="iconUrl" />
    <div class="meta">
      <router-link class="name" v-if="route" :to="route">{{
        title
      }}</router-link>
      <div v-else class="name">{{ title }}</div>
      <div class="count" v-if="activeWithScProjectText">
        {{ activeWithScProjectText }}
      </div>
      <div class="count" v-else-if="showProjectCount">
        เปิดใช้งานอยู่ทั้งหมด {{ projectCount }} โครงการ
      </div>
      <div class="status">
        <span v-if="disable" style="color: red">●</span>
        <span v-if="!disable" style="color: green">●</span>
        {{ isDisable }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    "iconUrl",
    "title",
    "route",
    "projectCount",
    "order",
    "disable",
    "isAllScProjects",
    "isAllNonScProjects"
  ],
  computed: {
    showProjectCount() {
      return this.projectCount !== null || this.projectCount !== "undefined";
    },
    activeWithScProjectText() {
      if (this.isAllScProjects === true && this.isAllNonScProjects === true) {
        return "เปิดใช้งานอยู่ทั้งหมด ยกเว้น Building / Warehouse";
      } else if (this.isAllScProjects === true)  {
        return "เปิดใช้งานเฉพาะโครงการ SC";
      } else if (this.isAllNonScProjects === true)  {
        return "เปิดใช้งานเฉพาะโครงการที่ไม่ใช่ SC";
      } else {
        return null;
      }
    },
    isDisable() {
      if (this.disable === true) {
        return "ปิดใช้บริการ"
      } else return "เปิดใช้บริการ"
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";
$iconSize: 48px;

.juristic-feature-row {
  display: grid;
  grid-template-columns: 48px auto;
  grid-gap: 30px;

  align-items: center;

  border-bottom: $border;
  padding: ($space / 2) $space;

  > .icon {
    display: block;

    border-radius: 8px;
    width: $iconSize;
    height: $iconSize;
  }

  > .meta {
    display: block;
  }
}

.meta > .name {
  line-height: 1.6;
  display: inline-block;

  &:hover {
    color: black;
  }
}

.count {
  font-size: 14px;
}

.status {
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/features/juristic-feature/components/JuristicFeatureRow.vue